export default __webpack_public_path__ + "static/media/avatar_mei_ling4.0d27e5af.mp3";